import { useEffect, useState } from "react";
import { ProductRail } from "@/components/ProductCard";
import { api } from "@/lib/api";

// "You might also like" — related products from the same category.
export default function YouMightLike({ category, excludeId, title = "You Might Also Like" }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!category) return;
    api.get("/products", { params: { category, limit: 14 } })
      .then(({ data }) => setItems(data.filter((p) => p.id !== excludeId).slice(0, 12)))
      .catch(() => {});
  }, [category, excludeId]);
  if (items.length < 3) return null;
  return (
    <div data-testid="you-might-like">
      <ProductRail title={title} products={items} />
    </div>
  );
}
